import { StyledFileImg, StyledLi, StyledTextSpan } from './LayoutRow.styled';

interface ILayoutRowProps {
	name: string;
}

const LayoutRow: React.FC<ILayoutRowProps> = ({ name: layoutName }) => {
	const baseUrl = window.location.href;
	return (
		<StyledLi>
			<a href={`${baseUrl}?layouts=${layoutName}`} title={layoutName}>
				<StyledFileImg />
				<StyledTextSpan>{layoutName}</StyledTextSpan>
			</a>
		</StyledLi>
	);
};

export { LayoutRow };
